import { ConnectorServiceEnum } from '@enum/connector-service.enum';

export const isHris = (serviceId: string) =>
  serviceId === ConnectorServiceEnum.AlexisHR ||
  serviceId === ConnectorServiceEnum.BambooHR ||
  serviceId === ConnectorServiceEnum.Hibob ||
  serviceId === ConnectorServiceEnum.HibobOauth ||
  serviceId === ConnectorServiceEnum.HaileyHR;
